import {
  CHAT_MESSAGE, CHAT_CLEAR, CHAT_PURGE, CHAT_DELETE,
} from '@/utils/constants/socket-events'
import ChatMessage from '@/store/models/chat/ChatMessage'

export default {
  async [`SOCKET_${CHAT_MESSAGE}`](_, data) {
    const message = new ChatMessage(data)
    await message.$save()

    // TODO process ping sound
    // TODO process notification?
  },
  async [`SOCKET_${CHAT_CLEAR}`](_, room) {
    await ChatMessage.delete(msg => msg.room === room)
  },
  async [`SOCKET_${CHAT_PURGE}`](_, { steamid, room }) {
    await ChatMessage.update({
      where: msg => msg.user?.steamid === steamid && msg.room === room,
      data: {
        deleted: true,
      },
    })
  },
  async [`SOCKET_${CHAT_DELETE}`](_, { id }) {
    await ChatMessage.update({
      where: id,
      data: {
        deleted: true,
      },
    })
  },
}
